import { css } from '@emotion/css';
import { computed } from 'vue';
import { useTheme } from '../../composables/theme';

export const useStyles = () => {
  const theme = useTheme();

  const baseClass = computed(() => css({
    '&, *': {
      margin: 0,
      padding: 0,
      boxSizing: 'border-box',
      fontFamily: theme.value.typography.fontFamily,
    },
    '&__container': {
      gap: theme.value.spacing,
      display: 'flex',
      flexDirection: 'column',
      width: '358px',
    },
    '&__label': {
      color: theme.value.typography.color,
      display: 'block',
      fontSize: '13px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '20px',
    },
    '&__input-wrapper': {
      position: 'relative',
    },
    '&__input': {
      color: '#373737',
      display: 'flex',
      width: '100%',
      background: '#FFF',
      border: `1px solid ${theme.value.colors.gray.light2}`,
      borderRadius: theme.value.input.borderRadius,
      padding: '6px 8px',
      gap: '8px',
      fontSize: '13px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '9px',
      '&::placeholder': {
        color: theme.value.colors.gray.medium2,
      },
      '&:hover': {
        borderColor: theme.value.colors.gray.medium2,
      },
      '&:focus': {
        borderColor: theme.value.colors.primary.light1,
      },
      '&:focus-visible': {
        outline: 'none',
      },
      '&:disabled': {
        background: theme.value.colors.gray.light3,
        borderColor: theme.value.colors.gray.light3,
      },
      '&--left-icon': {
        paddingLeft: '32px',
      },
      '&--right-icon': {
        paddingRight: '32px',
      },
    },
    '&__icon': {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      fontSize: '12px',
      '&--left': {
        left: '8px',
      },
      '&--right': {
        right: '8px',
      },
    },
    '&__helper-text': {
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '18px',
      color: theme.value.colors.gray.medium1,
    },
    '&--error &__input, &error &__input:focus': {
      borderColor: theme.value.colors.error,
    },
    '&--error &__helper-text': {
      color: theme.value.colors.error,
    },
    '&--full-width': {
      width: '100%',
    },
    '&--multiline &__input': {
      height: '80px',
      overflow: 'auto',
      resize: 'none',
    },
    '&--multiline &__icon': {
      top: 0,
      transform: 'translateY(50%)',
    },
  }));

  return baseClass;
};
